import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { IonicSelectableComponent } from 'ionic-selectable';
import { UtilService } from '../../../service/util.service';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-service-level',
  templateUrl: './service-level.component.html',
  styleUrls: ['./service-level.component.scss'],
})
export class ServiceLevelComponent implements OnInit {

  @Input() counterList: any[];
  @Input() warehouseList: any[];
  @Input() branchList: any[];
  @Input() paramProductRequestId: any;
  @Input() paramBranchIdList: any;
  @Input() paramCounterIdList: any;
  @Input() paramWarehouseIdList: any;
  @Input() paramDocStartDate: any;
  @Input() paramDocEndDate: any;
  @Input() paramPoType: any;

  selectedBranchs:any[];
  selectedCounters: any[];
  selectedWarehouses: any[];
  docStartDate:any='';
  docEndDate:any='';
  branchIdList:any='';
  counterIdList:any='';
  warehouseIdList:any='';
  counterId:any[]=[];
  invalid:number=0;
  counterListMaster:any[]=[];
  warehouseListMaster:any[]=[];
  poType:any=0;

  @ViewChild('branchComponent', { static: false }) branchComponent: IonicSelectableComponent;
  @ViewChild('counterComponent', { static: false }) counterComponent: IonicSelectableComponent;
  @ViewChild('warehouseComponent', { static: false }) warehouseComponent: IonicSelectableComponent;
    
  constructor(
    private modalController:ModalController,
    private utilService:UtilService) { }

  ngOnInit() {
    this.counterListMaster = this.counterList.slice(0);
    this.warehouseListMaster = this.warehouseList.slice(0);
  }
  ionViewDidEnter(){
    this.selectedBranchs =[];
    this.selectedCounters = [];
    this.selectedWarehouses = [];
    this.setDefaultBranchs();
    this.docStartDate  = this.paramDocStartDate;
    this.docEndDate  = this.paramDocEndDate;
    this.poType = this.paramPoType;
  }
  setDefaultBranchs() {
    var i, j;
    this.selectedBranchs = [];
    for (i = 0; i < this.branchList.length; i++) {
      for (j = 0; j < this.paramBranchIdList.length; j++) {
        if (this.branchList[i].id === this.paramBranchIdList[j]) {
          this.selectedBranchs.push(this.branchList[i]);
          break;
        }
      }
    }
    this.setDefaultCounters();
  }
  setDefaultCounters() {
    this.selectedCounters = [];
    this.counterList = this.counterListMaster.slice(0);
    // kalau tidak pilih branch → balikin semua
    if (this.selectedBranchs.length === 0) {
      for (var i = 0; i < this.counterList.length; i++) {
        if (this.paramCounterIdList.indexOf(this.counterList[i].id) !== -1) {
          this.selectedCounters.push(this.counterList[i]);
        }
      }
    }
    else{    
      // ambil list branch_id yang dipilih
      var branchIds = [];
      for (var b = 0; b < this.selectedBranchs.length; b++) {
        branchIds.push(this.selectedBranchs[b].id);
      }

      // filter counter sesuai branch
      var filteredCounter = [];
      for (var i = 0; i < this.counterListMaster.length; i++) {
        if (branchIds.indexOf(this.counterListMaster[i].branch_id) !== -1) {
          filteredCounter.push(this.counterListMaster[i]);
        }
      }

      // set hasil filter
      this.counterList = filteredCounter;
      for (var i = 0; i < this.counterList.length; i++) {
        if (this.paramCounterIdList.indexOf(this.counterList[i].id) !== -1) {
          this.selectedCounters.push(this.counterList[i]);
        }
      }

    }
    this.setDefaultWarehouses();
    
  }
  setDefaultWarehouses() {
    
    this.selectedWarehouses = [];
    this.warehouseList = this.warehouseListMaster.slice(0);
    if (this.selectedCounters.length === 0) {
      for (var i = 0; i < this.warehouseList.length; i++) {
        if (this.paramWarehouseIdList.indexOf(this.warehouseList[i].id) !== -1) {
          this.selectedWarehouses.push(this.warehouseList[i]);
        }
      }
    }
    else{    
      // ambil list branch_id yang dipilih
      var counterIds = [];
      for (var b = 0; b < this.selectedCounters.length; b++) {
        counterIds.push(this.selectedCounters[b].id);
      }

      // filter warehouse sesuai counter
      var filteredWarehouse = [];
      for (var i = 0; i < this.warehouseListMaster.length; i++) {
        if (counterIds.indexOf(this.warehouseListMaster[i].counter_id) !== -1) {
          filteredWarehouse.push(this.warehouseListMaster[i]);
        }
      }

      // set hasil filter
      this.warehouseList = filteredWarehouse;
      
      for (var i = 0; i < this.warehouseList.length; i++) {
      if (this.paramWarehouseIdList.indexOf(this.warehouseList[i].id) !== -1) {
          this.selectedWarehouses.push(this.warehouseList[i]);
        }
      }

    }
  }

  async dismissModal(code: any) {
    let dataReturn: any[] = [];
    this.invalid =0;
    if(code === 'generate') {
      this.validateDocDate();
      if(this.invalid==0){
        let convertDocStartDate = null;
        let convertDocEndDate   = null;
        if(this.docStartDate){
          convertDocStartDate = this.utilService.convertDate(this.docStartDate);
          this.docStartDate = convertDocStartDate.years + '-' + convertDocStartDate.months + '-' + convertDocStartDate.dates;
        }
        if(this.docEndDate){
          convertDocEndDate = this.utilService.convertDate(this.docEndDate);
          this.docEndDate = convertDocEndDate.years + '-' + convertDocEndDate.months + '-' + convertDocEndDate.dates;
        }
        let counterNameList = '';//this.counterId ? this.counterList.find(x => x.id === this.counterId) : null;
        let warehouseNameList ='';// this.warehouseId !== null || this.warehouseId !== undefined ? this.warehouseList.find(x => x.id === this.warehouseId) : null;
        let data = {
          productRequestId: this.paramProductRequestId ? this.paramProductRequestId : null,
          branchId: this.selectedBranchs,
          counterId: this.selectedCounters,
          counterName: counterNameList,
          warehouseId: this.selectedWarehouses,
          warehouseName : warehouseNameList,
          docStartDate: this.docStartDate,
          docEndDate: this.docEndDate,
          poType:this.poType
        };
        dataReturn.push(data);
        await this.modalController.dismiss(dataReturn);
      }
    }
    if(code === 'close') {
      dataReturn = [];
      await this.modalController.dismiss(dataReturn);
    }
  }
  toggleBranchItems() {
    this.branchComponent.toggleItems(
      this.branchComponent.itemsToConfirm.length ? false : true
    );
  }
  confirmBranch() {
    this.branchComponent.confirm();
    this.branchComponent.close();

    var idBranch = [];
    var i;
    this.selectedCounters = [];
    this.selectedWarehouses = [];

    for (i = 0; i < this.selectedBranchs.length; i++) {
      idBranch.push(this.selectedBranchs[i].id);
    }

    // kalau tidak pilih branch → balikin semua
    if (idBranch.length === 0) {
      this.counterList = this.counterListMaster.slice(0);
      this.warehouseList = this.warehouseListMaster.slice(0);
      return;
    }

    // FILTER COUNTER (dari master)
    var filteredCounter = [];
    for (i = 0; i < this.counterListMaster.length; i++) {
      if (idBranch.indexOf(this.counterListMaster[i].branch_id) !== -1) {
        filteredCounter.push(this.counterListMaster[i]);
      }
    }
    this.counterList = filteredCounter;

    // ambil counter_id
    var counterIds = [];
    for (i = 0; i < this.counterList.length; i++) {
      counterIds.push(this.counterList[i].id);
    }

    // FILTER WAREHOUSE (dari master)
    var filteredWarehouse = [];
    for (i = 0; i < this.warehouseListMaster.length; i++) {
      if (counterIds.indexOf(this.warehouseListMaster[i].counter_id) !== -1) {
        filteredWarehouse.push(this.warehouseListMaster[i]);
      }
    }
    this.warehouseList = filteredWarehouse;
  }

  toggleCounterItems() {
    this.counterComponent.toggleItems(
      this.counterComponent.itemsToConfirm.length ? false : true
    );
  }

  confirmCounter() {
    this.counterComponent.confirm();
    this.counterComponent.close();

    var idCounter = [];
    var i;
    
    var counterIds = [];
    this.selectedWarehouses = [];

    for (i = 0; i < this.selectedCounters.length; i++) {
      idCounter.push(this.selectedCounters[i].id);
      counterIds.push(this.selectedCounters[i].id);
    }
    // kalau tidak pilih counter → balikin semua
    if (idCounter.length === 0) {
      this.warehouseList = this.warehouseListMaster.slice(0);
      return;
    }
    // FILTER WAREHOUSE (dari master)
    var filteredWarehouse = [];
    for (i = 0; i < this.warehouseListMaster.length; i++) {
      if (counterIds.indexOf(this.warehouseListMaster[i].counter_id) !== -1) {
        filteredWarehouse.push(this.warehouseListMaster[i]);
      }
    }
    this.warehouseList = filteredWarehouse;
  }
  toggleWarehouseItems() {
    this.warehouseComponent.toggleItems(
      this.warehouseComponent.itemsToConfirm.length ? false : true
    );
  }

  confirmWarehouse() {
    this.warehouseComponent.confirm();
    this.warehouseComponent.close();
    let idWarehouse= [];
    for(let i=0;i<this.selectedWarehouses.length;i++){
      idWarehouse.push(this.selectedWarehouses[i].id);
    }
  }
  validateDocDate() {
    // BOLEH KOSONG → langsung stop
    if (!this.docStartDate || !this.docEndDate) {
      return;
    }

    const start = new Date(this.docStartDate + 'T00:00:00');
    const end   = new Date(this.docEndDate + 'T00:00:00');

    if (isNaN(start.getTime()) || isNaN(end.getTime())) {
      return;
    }

    if (end < start) {
      alert('Tanggal akhir tidak boleh lebih kecil dari tanggal awal');
      this.invalid++;
      this.docEndDate = null;
    }
  }

}
